import apiRequest from "../../services/apiRequest";
import moment from "moment";

export default {
  namespaced: true,
  state: {
    sortedSignalsFromService: [],
    signals: [],
    symbols: {},

    displayedSignals: [],
    busy: false,
    initialAmount: 30,

    showFilters: false,
    selectAll: true,
    searchSymbol: "",
    validityList: ["validity_hourly", "validity_weekly", "validity_monthly"],
    showSignalModal: false,
    currentDisplayedSignal: {}
  },
  getters: {
    checkedSignals: state => {
      return state.signals.filter(
        signal =>
          state.symbols[signal.symbol].checked &&
          state.validityList.indexOf(signal.validity) > -1
      );
    },
    searchedSymbols: state => {
      let symbols = state.symbols;
      let result = {};
      for (let key in symbols) {
        if (
          symbols[key].name
            .toLowerCase()
            .includes(state.searchSymbol.toLowerCase())
        ) {
          result[key] = symbols[key];
        }
      }
      return result;
    },
    moreSignalsAvailable: (state, getters) => {
      return state.displayedSignals.length < getters.checkedSignals.length;
    }
  },
  mutations: {
    setSortedSignalsFromService(state, sortedSignals) {
      state.sortedSignalsFromService = sortedSignals;
    },
    setDynamicScrollFlag(state, status) {
      state.busy = status;
    },
    setDisplayedSignals(state, signalList) {
      state.displayedSignals = signalList;
    },
    setSignals(state, signals) {
      state.signals = signals;
    },

    setShowFilters(state, showFilters) {
      if (showFilters && window.innerWidth < 600) {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        document.documentElement.style.overflow = "hidden";
      } else {
        document.documentElement.style.overflow = "auto";
      }
      state.showFilters = showFilters;
    },

    setCheckedSymbol(state, symbol) {
      state.symbols[symbol.name].checked = !state.symbols[symbol.name].checked;
    },

    selectAllSymbols(state, selectAll) {
      state.selectAll = selectAll;
      for (let key in state.symbols) {
        state.symbols[key].checked = selectAll;
      }
    },

    toggleValidity(state, validity) {
      let validityString = state.validityList.indexOf(validity);
      if (validityString === -1) {
        state.validityList.push(validity);
      } else {
        state.validityList.splice(validityString, 1);
      }
    },

    setSymbols(state, signals) {
      let updatedSymbols = {...state.symbols};
      signals.forEach(signal => {
        if (!updatedSymbols[signal.symbol]) {
          updatedSymbols[signal.symbol] = {
            name: signal.symbol,
            image: signal.symbolImage,
            checked: true,
            validity: [signal.validity]
          };
        } else {
          !updatedSymbols[signal.symbol].validity.includes(signal.validity) &&
          updatedSymbols[signal.symbol].validity.push(signal.validity);
        }
      });
      state.symbols = updatedSymbols;
    },


    setSearchSymbol(state, newVal) {
      state.searchSymbol = newVal;
    },

    resetSearch(state) {
      state.searchSymbol = "";
    },
    setShowSignalModal(state, { showPopup, signal }) {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      state.showSignalModal = showPopup;
      state.currentDisplayedSignal = showPopup ? signal : {};
    }
  },
  actions: {
    initSignalList({ state, commit, getters }) {
      commit("setDynamicScrollFlag", true);
      commit("setDisplayedSignals", []);
      let newDisplayedSignals = [];
      for (let i = 0; i < state.initialAmount; i++) {
        if (getters.checkedSignals[i]) {
          newDisplayedSignals.push(getters.checkedSignals[i]);
        } else {
          break;
        }
      }
      commit("setDisplayedSignals", newDisplayedSignals);
      commit("setDynamicScrollFlag", false);
      window.scrollTo(0, 0);
    },
    updateSignalsList({ state, commit, getters }) {
      commit("setDynamicScrollFlag", true);
      const loadAmount = 18;
      let currLength = state.displayedSignals.length;
      let destLength = currLength + loadAmount;

      let newDisplayedSignals = [...state.displayedSignals];
      for (let i = currLength; i < destLength; i++) {
        if (getters.checkedSignals[i]) {
          newDisplayedSignals.push(getters.checkedSignals[i]);
        } else {
          break;
        }
      }
      commit("setDisplayedSignals", newDisplayedSignals);
      commit("setDynamicScrollFlag", false);
    },
    getSignalsFromService({ commit, rootState, rootGetters }, symbol) {
      commit("incrementPendingApiCallsCount", null, { root: true });
      const product = !symbol ? null : symbol;
      let payload = {
        lang: rootState.lang,
        product: product,
        term: null
      };
      apiRequest
        .post(rootGetters.baseApiUrl() + "visitor/signals", payload)
        .then(function(json) {
          json.data.sort((a, b) => moment(b.time) - moment(a.time));
          commit("setSortedSignalsFromService", json.data);
          commit("decrementPendingApiCallsCount", null, { root: true });
        });
    },
    loadUserSignals({ state, commit, rootGetters }) {
      //todo: call it asynchrony
      let displayData;
      if (rootGetters.loggedAndActive) {
        displayData = state.sortedSignalsFromService;
      } else {
        displayData = state.sortedSignalsFromService
          .filter(
            (
              signal //todo: rewrite it
            ) =>
              signal.symbol === "EURUSD" ||
              signal.symbol === "AMAZON" ||
              signal.symbol === "BTCUSD" ||
              signal.symbol === "GBPUSD" ||
              signal.symbol === "USDJPY" ||
              signal.symbol === "XAUUSD" ||
              signal.symbol === "APPLE" ||
              signal.symbol === "TSLA"
          )
          .slice(0, 6);
      }
      commit("setSignals", displayData);
      commit("setSymbols", displayData);
    }
  }
};
